import { Injectable } from '@angular/core';
import { IFormMasterBuilder, IFormFieldErrorMessages } from 'i2g-ng-ui';
import {
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';

@Injectable()
export class SetPasswordFormBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    PASSWORD: 'password',
    CONFIRM_PASSWORD: 'confirm_password',
  };

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(): FormGroup {
    const formKeys = this.FORM_KEYS;

    return this._formBuilder.group(
      {
        [formKeys.PASSWORD]: [
          '',
          [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(250),
          ],
        ],
        [formKeys.CONFIRM_PASSWORD]: [
          '',
          [
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(250),
          ],
        ],
      },
      {
        validators: this.buildPasswordsMatchValidator,
      }
    );
  }

  buildPasswordsMatchValidator(control: FormGroup): ValidationErrors | null {
    const password = control.get('password');
    const confirm_password = control.get('confirm_password');

    if (
      !password.value ||
      password.invalid ||
      !confirm_password.value ||
      confirm_password.invalid
    ) {
      return null;
    }

    return password.value !== confirm_password.value
      ? { mustMatch: true }
      : null;
  }

  buildPasswordErrorMessages(): IFormFieldErrorMessages {
    return {
      min: {
        message: 'FORM.PASSWORD.MIN_LENGTH_ERROR',
      },
      mustMatch: {
        message: 'FORM.CONFIRM_PASSWORD.MISMATCH_ERROR',
      },
    };
  }
}
